import { render, staticRenderFns } from "./TaiwanCurrency.vue?vue&type=template&id=59ebb8e3&scoped=true"
import script from "./TaiwanCurrency.vue?vue&type=script&lang=js"
export * from "./TaiwanCurrency.vue?vue&type=script&lang=js"
import style0 from "./TaiwanCurrency.vue?vue&type=style&index=0&id=59ebb8e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ebb8e3",
  null
  
)

export default component.exports